if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-modal-nav="prev"]');
        this.nextButton = this.querySelector('[data-modal-nav="next"]');

        [this.prevButton, this.nextButton].forEach((button) => {
          button?.addEventListener('pointerup', (event) => {
            event.preventDefault();
            event.stopPropagation();
          });
          button?.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.showAdjacentMedia(button === this.prevButton ? -1 : 1);
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]'));
      }

      getActiveMediaIndex() {
        return this.getMediaItems().findIndex((element) =>
          element.classList.contains('active'),
        );
      }

      showAdjacentMedia(direction) {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;

        const activeIndex = this.getActiveMediaIndex();
        const nextIndex =
          activeIndex >= 0
            ? (activeIndex + direction + mediaItems.length) % mediaItems.length
            : 0;
        const nextMedia = mediaItems[nextIndex];
        if (!nextMedia) return;

        this.openedBy?.setAttribute('data-media-id', nextMedia.dataset.mediaId);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`,
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`,
        );
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add('active');

        const container =
          this.modalContent || this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    },
  );
}
